











































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import * as GROUPS_QUERY from 'src/graphql/admin/Groups.graphql';

@Component({
  apollo: {
    groups: {
      query: GROUPS_QUERY,
      fetchPolicy: 'network-only',
    },
  }
})
export default class AdministrationView extends Vue {
  model = '0';
  groups = [];

  @Watch('groups')
  onGroupsChanged() {
    this.$store.commit('setGroups', this.groups);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdministrationView.vue